import { useTenantId } from "hooks/useTenantId";
import { useMemo } from "react"

import { ReactComponent as MissionIcon } from '../icons/mission.svg';
import { ReactComponent as AboutIcon } from '../icons/about-us.svg';
import{ ReactComponent as ContactIcon } from '../icons/contact-us.svg';

export const useLinks = () => {
  const tenantId = useTenantId();
 
  return useMemo(() => {
    const routes = [
      {
        label: 'Why Ennabl',
        Icon: MissionIcon,
        to: 'https://www.ennabl.com/why-ennabl',
      },
      {
        label: 'About Us',
        Icon: AboutIcon,
        to: 'https://www.ennabl.com/about/team',
      },
      {
        label: 'Contact Us',
        Icon: ContactIcon,
        to: 'https://www.ennabl.com/about/contact-us',
      },
    ]

    console.log({tenantId});

    if (tenantId === 'bstot5') {
      return routes.map(route => {
        if (route.label === 'Contact Us') {
          return {
            Icon: route.Icon,
            label: 'Contact ISU Support',
            to: 'https://isusteadfast.com/contact-us',
          }
        }
        return route;
      })
    }

    if (tenantId === 'bl7mcb') {
      return routes.map(route => {
        if (route.label === 'Contact Us') {
          return {
            Icon: route.Icon,
            label: 'Contact PIIB Support',
            to: 'https://www.piib.com/contact-us/',
          }
        }
        return route;
      })
    }
    
    return routes;
  }, [tenantId]);
}